import Api from '../common/Api';
import {Backend, headers} from "../common/Config";
import Helpers from '../common/Helpers';

export default class Mantenimiento {

    static async save(form) {
        const response = await Api.post({
            url: `${Backend}/mantenimiento/create`,
            form,
            headers: headers
        });
        return Helpers.dataReturn(response);
    };

    static async update(form) {
        const response = await Api.post({
            url: `${Backend}/mantenimiento/update`,
            form,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async getState(page = 0, state = 0, form) {
        const response = await Api.post({
            url: `${Backend}/mantenimiento/state/${page}/${state}`,
            form,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async get(page = 0) {
        const response = await Api.get({
            url: `${Backend}/mantenimiento/list/${page}`,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async getById(id) {
        const response = await Api.get({
            url: `${Backend}/mantenimiento/get/${id}`,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async getByDate(init, end) {
        const response = await Api.get({
            url: `${Backend}/mantenimiento/date/${encodeURIComponent(init)}/${encodeURIComponent(end)}`,
            headers
        });
        return Helpers.dataReturn(response);
    };

}
